import React from "react";
import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, actions, className }) => (
  <div className={cn("mb-4 flex items-start justify-between gap-3", className)}>
    <div className="min-w-0">
      <h1 className="truncate text-2xl font-bold text-foreground sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-0.5 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
  </div>
);
